<template>
    <div class="business-nav">
        <div
            v-for="(name, i) in navData.menuNames"
            class="business-nav-menu" @click="handleClick(name.name)"
            :class="{'business-nav-menu-selected': navData.activeName == name.name}"
            :key="i"><img :src="name.icon">{{ name.name }}</div>
    </div>
</template>

<script>
export default {
    name: "businessNav",
    props: {
        navData: Object
    },
    setup(props, { emit }) {
        const handleClick = (name) => {
            emit('navClick', name)
        }
        return {
            handleClick,
        }
    }
}
</script>

<style scoped lang="stylus">
    .business-nav {
        width 100%
        height 40px
        display flex
        flex-wrap nowrap
        justify-content space-evenly
        .business-nav-menu {
            width 100px
            height 40px
            line-height 40px
            color #FFF
            background-color #BFBFBF
            font-size 12px
            text-align center
            border-radius 8px
        }
        .business-nav-menu img {
            width 20px
            height 20px
            margin-right 5px
        }
        .business-nav-menu-selected {
            background-color #7CA335
        }
    }
</style>